// src/pages/Project/components/ProjectTabs.tsx
import React from "react";

interface ProjectPageTabsProps {
  activeTab: string;
  handleTabClick: (tab: string) => void;
  tabsDisabled?: boolean;
  loading?: boolean;
  canViewProjectFiles?: boolean;
}

const ProjectPageTabs: React.FC<ProjectPageTabsProps> = ({
  activeTab,
  handleTabClick,
  tabsDisabled = false,
  loading = false,
  canViewProjectFiles = false,
}) => {
  return (
    <div className="flex items-end font-medium space-x-4 justify-between h-[65px] 2xl:h-[70px]">
      {/* Overview */}
      <button
        onClick={() => handleTabClick("Overview")}
        className={`border-b-[3px] px-2 pb-5 text-sm 2xl:text-base cursor-pointer ${
          activeTab === "Overview"
            ? " border-b-[3px] border-[#0357C9]"
            : "text-gray-400 border-transparent"
        } ${tabsDisabled && "cursor-wait"}`}
        type="button"
      >
        Overview
      </button>

      {/* Documents (conditional) */}
      {(loading || canViewProjectFiles) && (
        <button
          onClick={() => handleTabClick("Documents")}
          className={`border-b-[3px] px-2 pb-5 text-sm 2xl:text-base cursor-pointer ${
            activeTab === "Documents"
              ? " border-b-[3px] border-[#0357C9]"
              : "text-gray-400 border-transparent"
          } ${tabsDisabled && "cursor-wait"}`}
          type="button"
        >
          Documents
        </button>
      )}

      {/* Reports */}
      <button
        onClick={() => handleTabClick("Reports")}
        className={`border-b-[3px] px-2 pb-5 text-sm 2xl:text-base cursor-pointer  ${
          activeTab === "Reports"
            ? " border-b-[3px] border-[#0357C9]"
            : "text-gray-400 border-transparent"
        } ${tabsDisabled && "cursor-wait"}`}
        type="button"
      >
        Reports
      </button>
    </div>
  );
};

export default ProjectPageTabs;
